<template>
  <router-view />
</template>

<script>
export default {
  name: "basedoc",
};
</script>